<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <div id="spinner" v-if="datamaster.length == 0"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">STATUS PENGADAAN</span>
                <span v-else>PROCUREMENT STATUS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Status Pengadaan</span>
                    <span v-else>Procurement Status</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                        style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                        <div class="sub-style">
                            <h5 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                                Tanggal Data: {{ G_formatDateNonWIB(datadate) }}
                            </h5>
                            <h5 class="sub-title px-3 mb-0 labelpmis" v-else>
                                Data Date: {{ G_formatDateNonWIBEng(datadate) }}
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                        <div class="row justify-content-center">
                            <div class="col-sm-12 text-center">
                                <div class="sub-style">
                                    <h5 v-if="(bahasa === null) || (bahasa == 'ina')" class="px-3 mb-0 labelpmis">
                                        {{ urutlist + 1 }}. Pengadaan {{ datalist.Jenis }}
                                    </h5>
                                    <h5 v-else class="px-3 mb-0 labelpmis">
                                        {{ urutlist + 1 }}. {{ datalist.Jenis }} Procurement
                                    </h5>
                                </div>
                                <br>
                                <a class="hitam">
                                    <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                        data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                        @click="G_tableCSVTabel1('_Data_Procurement_', datalist.Jenis)">
                                        <i class="fas fa-download"></i>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Unduh Data .xlsx
                                        </span>
                                        <span v-else>
                                            Download Data .xlsx
                                        </span>
                                    </button>
                                </a>
                            </div>
                            <div class="col-sm-12 text-center">&nbsp;</div>
                            <div class="col-sm-12">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" style="font-size: x-small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;" rowspan="2">
                                                    No
                                                </th>
                                                <th style="width: 250px;" rowspan="2">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        CPMU / NPIU / CPIU / PIU<br></br>
                                                        Paket Pekerjaan
                                                    </span>
                                                    <span v-else>
                                                        CPMU / NPIU / CPIU / PIU<br></br>
                                                        Work Packages
                                                    </span>
                                                </th>
                                                <th style="width: 100px;" rowspan="2">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        OWP (IDR)
                                                    </span>
                                                    <span v-else>
                                                        OWP (IDR)
                                                    </span>
                                                </th>
                                                <th style="width: 100px;" rowspan="2">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Tahapan Paket
                                                    </span>
                                                    <span v-else>
                                                        Package Stages
                                                    </span>
                                                </th>
                                                <template v-for="(dataTahapan, urutTahapan) in datalist.Tahapan"
                                                    :key="urutTahapan">
                                                    <th :colspan="dataTahapan.colspan">
                                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                            {{ dataTahapan.nama_indo }}
                                                        </span>
                                                        <span v-else>
                                                            {{ dataTahapan.nama }}
                                                        </span>
                                                    </th>
                                                </template>
                                            </tr>
                                            <tr>
                                                <template v-for="(dataTahapan, urutTahapan) in datalist.Tahapan"
                                                    :key="urutTahapan">
                                                    <template
                                                        v-for="(dataDetailTahapan, urutDetailTahapan) in dataTahapan.tahapan"
                                                        :key="urutDetailTahapan">
                                                        <th style="width: 50px;">
                                                            {{ dataDetailTahapan.nama }}
                                                        </th>
                                                    </template>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(dataPIU, urutPIU) in datalist.PIU" :key="urutPIU">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center levelkomponen">
                                                        {{ urutPIU + 1 }}
                                                    </td>
                                                    <td :colspan="dataPIU.colspan + 3" class="levelkomponen">
                                                        {{ dataPIU.nama_piu }}
                                                    </td>
                                                </tr>
                                                <template v-for="(dataSATKER, urutSATKER) in dataPIU.SATKER"
                                                    :key="urutSATKER">
                                                    <tr>
                                                        <td class="text-center levelsubkegiatan">
                                                            {{ urutPIU + 1 }} . {{ urutSATKER + 1 }}
                                                        </td>
                                                        <td :colspan="dataPIU.colspan + 3" class="levelsubkegiatan">
                                                            {{ dataSATKER.nama_satker }}
                                                        </td>
                                                    </tr>
                                                    <template
                                                        v-for="(dataPaketPekerjaan, urutPaketPekerjaan) in dataSATKER.PaketPekerjaan"
                                                        :key="urutPaketPekerjaan">
                                                        <tr>
                                                            <td class="text-center" :class="dataPaketPekerjaan.class">
                                                                {{ urutPaketPekerjaan + 1 }}
                                                            </td>
                                                            <td :class="dataPaketPekerjaan.class">
                                                                {{ dataPaketPekerjaan.Nama_Kegiatan }}
                                                            </td>
                                                            <td class="text-right" :class="dataPaketPekerjaan.class">
                                                                {{ G_numFormat(dataPaketPekerjaan.OWP) }}
                                                            </td>
                                                            <td :class="dataPaketPekerjaan.class">
                                                                {{ dataPaketPekerjaan.Status_pekerjaan }}
                                                            </td>
                                                            <template
                                                                v-for="(dataTAHAPAN, urutTAHAPAN) in dataPaketPekerjaan.TAHAPAN"
                                                                :key="urutTAHAPAN">
                                                                <template
                                                                    v-for="(dataisiTAHAPAN, urutisi) in dataTAHAPAN.tahapan"
                                                                    :key="urutTAHAurutisiPAN">
                                                                    <td class="text-center"
                                                                        :class="dataisiTAHAPAN.class">
                                                                        {{ dataisiTAHAPAN.cektahap }}
                                                                    </td>
                                                                </template>
                                                            </template>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-12 text-center">
                                &nbsp;
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>

    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, vSelect
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datadate: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async G_tableCSVTabel1(namefile, jenis) {
            if (jenis == 'Civil Work') {
                var type_work = '0';
            }
            if (jenis == 'Consultant') {
                var type_work = '1';
            }
            if (jenis == 'Goods') {
                var type_work = '2';
            }
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '_' + jenis + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakproc-Status?random=" + random + "&project_id=" + this.project_id + "&type_work=" + type_work + "&jenis=" + jenis).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoringupdate-StatusPengadaan?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&tahunpersiapan=" + this.selectedtahunpersiapan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.datadate = Response.data.content.datadate;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamaster = [];
                        this.datamaster.push('');
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.halamanloading = true;
        this.ambildata();
    },
}
</script>

<style></style>